/**
 * Mixpanel "dev mode": log every event to the console (events/mixpanelTrack.ts)
 * AND opt out of sending so events never reach the production project (index.tsx).
 *
 * On when:
 *  - running locally via `vite dev` (import.meta.env.DEV), or
 *  - VITE_APP_ENVIRONMENT is "dev" or "staging" — staging is a production *build*
 *    (so import.meta.env.DEV is false), but the staging deploy sets
 *    VITE_APP_ENVIRONMENT="staging" and we treat it exactly like local dev.
 *
 * Off in production (VITE_APP_ENVIRONMENT="production"), where events are sent
 * for real.
 */
export const isMixpanelDevMode = (): boolean => {
  if (import.meta.env.DEV) return true;
  const env = import.meta.env.VITE_APP_ENVIRONMENT;
  return env === "dev" || env === "staging";
};
